var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      ref: "suggestionList",
      tag: "div",
      class: ["list-group", _vm.matchedItems.length && "shadow"]
    },
    [
      _vm._l(_vm.matchedItems, function(item, id) {
        return _c(
          "vue-bootstrap-autocomplete-list-item",
          _vm._g(
            {
              key: id,
              attrs: {
                active: _vm.isListItemActive(id),
                id: _vm.isListItemActive(id)
                  ? "selected-option-" + _vm.vbtUniqueId
                  : false,
                data: item.data,
                htmlText: _vm.highlight(item.text),
                "aria-selected": _vm.isListItemActive(id) ? "true" : "false",
                screenReaderText: item.screenReaderText
                  ? item.screenReaderText
                  : item.text,
                disabled: _vm.isDisabledItem(item),
                backgroundVariant: _vm.backgroundVariant,
                backgroundVariantResolver: _vm.backgroundVariantResolver,
                textVariant: _vm.textVariant,
                role: "option"
              },
              nativeOn: {
                click: function($event) {
                  return _vm.handleHit(item, $event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "suggestion",
                    fn: function(ref) {
                      var data = ref.data
                      var htmlText = ref.htmlText
                      return _vm.$scopedSlots.suggestion
                        ? [
                            _vm._t("suggestion", null, null, {
                              data: data,
                              htmlText: htmlText
                            })
                          ]
                        : undefined
                    }
                  }
                ],
                null,
                true
              )
            },
            _vm.$listeners
          )
        )
      }),
      _vm._v(" "),
      _vm.query && _vm.showCreate
        ? _c(
            "li",
            {
              staticClass:
                "vbst-item list-group-item list-group-item-action disabled"
            },
            [
              [
                _vm._t("create", null, null, {
                  data: _vm.data,
                  htmlText: _vm.htmlText
                })
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.matchedItems.length == 0 &&
      (!!_vm.$scopedSlots.noResultsInfo || !!_vm.noResultsInfo)
        ? _c(
            "li",
            {
              staticClass:
                "vbst-item list-group-item list-group-item-action disabled",
              attrs: {
                id: "noResultsInfo",
                tabindex: "-1",
                disabled: "disabled",
                "aria-selected": "false"
              }
            },
            [
              _vm.$scopedSlots.noResultsInfo
                ? [
                    _vm._t("noResultsInfo", null, null, {
                      data: _vm.data,
                      htmlText: _vm.htmlText
                    })
                  ]
                : [_vm._v("\n      " + _vm._s(_vm.noResultsInfo) + "\n    ")]
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99cbbcbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99cbbcbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/autocomplete/VueBootstrapAutocompleteList.vue
// module id = null
// module chunks = 